import { Button, useColorModeValue, useOutsideClick } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ReactComponent as MoreIcon } from "src/icons/more-horiz.svg";
import IconAsButton from "src/components/IconAsButton";
import { useRef, useState } from "react";

export default function More({ openRenameFamilyDialog }) {
  const { t } = useTranslation();
  const ref = useRef(null);

  const [shouldShowMore, setShouldShowMore] = useState(false);
  const hoverBg = useColorModeValue(
    "rgba(0,0,0,0.08) ",
    "rgba(255,255,255,0.16)"
  );
  useOutsideClick({
    ref: ref,
    handler: () => setShouldShowMore(false)
  });

  return (
    <>
      {!shouldShowMore && (
        <IconAsButton
          size="20px"
          onClick={() => setShouldShowMore(true)}
          hoverBg="primaryLight"
          activeBg="primaryLight2"
          icon={MoreIcon}
          fill="primary"
          position="absolute"
          top="12px"
          right="16px"
        />
      )}
      {shouldShowMore && (
        <Button
          ref={ref}
          onClick={openRenameFamilyDialog}
          py="10px"
          px="8px"
          border="none"
          borderRadius="4px"
          bg="surfaceElevated1"
          color="highEmphasis"
          transition="all 200ms ease"
          _hover={{
            bg: hoverBg
          }}
          _active={{
            bg: "#cccccc"
          }}
          fontSize="14px"
          fontWeight="normal"
          lineHeight="1.14"
          letterSpacing="-0.1px"
          position="absolute"
          top="11px"
          right="11px"
          boxShadow="0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 1px 16px 0 rgba(0, 0, 0, 0.06), 0 4px 8px 0 rgba(0, 0, 0, 0.08)"
        >
          {t("buttons.renameFamily")}
        </Button>
      )}
    </>
  );
}
